function PrivacyPolicy() {
  return (
    <div className="p-10 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold mb-6">개인정보 처리방침</h2>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">1. 수집하는 개인정보 항목</h3>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed">
          <li>회원가입 시 필수: 디바이스 코드, 기관명, 기관 주소, 아이디, 비밀번호, 담당자 이메일, 담당자 연락처</li>
          <li>반려동물 등록 시 필수: 환자명, 생년월일, 체중, 성별, 종, 품종, 중성화 여부, 진단명</li>
          <li>선택항목: 입원일자, 주치의, 과거병력</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">2. 개인정보 수집 및 이용 목적</h3>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed">
          <li>사용자 인증 및 기기 연동을 통한 서비스 제공</li>
          <li>환자 생체신호 기반 건강 분석 및 리포트 생성</li>
          <li>기술 지원, 고객 상담, 문제 해결</li>
          <li>법적 의무 이행 및 통계 활용</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">3. 위치정보 처리에 관한 사항</h3>
        <p className="text-gray-700 leading-relaxed">
          <li>본 앱은 Bluetooth 기기 연결을 위해 사용자의 위치정보 접근 권한을 요청합니다.</li>
          <li>해당 권한은 BLE 장치 탐색 및 연결을 위한 기술적 요구사항이며, 사용자의 실제 위치를 저장하거나 전송하지 않습니다.</li>
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">4. 보유 및 이용 기간</h3>
        <p className="text-gray-700 leading-relaxed">
          회원 탈퇴 시까지 또는 관련 법령에 따라 보존합니다.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">5. 제3자 제공</h3>
        <p className="text-gray-700 leading-relaxed">
          법령에 따라 수사기관 등의 요청이 있을 경우에 한해 제공합니다.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">6. 이용자의 권리</h3>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed">
          <li>열람, 정정, 삭제, 처리정지 요청이 가능합니다.</li>
          <li>요청은 <a href="mailto:talktail@creamoff.co.kr" className="text-blue-600 underline">talktail@creamoff.co.kr</a> 로 접수 바랍니다.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">7. 개인정보 보호책임자</h3>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed">
          <li>이름: 권도혁</li>
          <li>직위: 대표자</li>
          <li>이메일: <a href="mailto:talktail@creamoff.co.kr" className="text-blue-600 underline">talktail@creamoff.co.kr</a></li>
        </ul>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
